import React from 'react';
import { Link } from 'react-router-dom';
import { useScript } from '../context/ScriptContext';
import { useDocumentTitle } from '../hooks/useDocumentTitle';

const TermsOfUsePage: React.FC = () => {
  const { t } = useScript();
  useDocumentTitle(t('Услови коришћења') + ' — ' + t('Манастир Градац'), '/uslovi-koriscenja');

  return (
    <div className="legal-page">
      <div className="legal-page-inner">
        <Link to="/" className="legal-back-link">{t('← Назад')}</Link>
        <h1 className="legal-page-title">{t('Услови коришћења')}</h1>
        <p className="legal-page-updated">{t('Последње ажурирање')}: 07. јул 2026.</p>

        <section className="legal-section">
          <h2>{t('Општи услови')}</h2>
          <p>
            {t('Коришћењем овог веб-сајта прихватате ове Услове коришћења. Молимо Вас да их пажљиво прочитате пре коришћења сајта.')}
          </p>
        </section>

        <section className="legal-section">
          <h2>{t('Ауторска права')}</h2>
          <p>
            {t('Сав садржај на овом веб-сајту, укључујући текстове, фотографије, графику и остале материјале, заштићен је ауторским правима у складу са Законом о ауторском и сродним правима Републике Србије („Сл. гласник РС", бр. 104/2009, 99/2011, 119/2012, 29/2016).')}
          </p>
          <p>
            {t('Забрањено је копирање, дистрибуција, јавно приказивање или било какво коришћење садржаја овог сајта без претходне писмене сагласности Манастира Градац.')}
          </p>
        </section>

        <section className="legal-section">
          <h2>{t('Коришћење фотографија')}</h2>
          <p>
            {t('Фотографије на овом веб-сајту су власништво аутора наведених на страници „Заслуге за фотографије". Свако неовлашћено коришћење фотографија је забрањено и представља кршење ауторских права.')}
          </p>
        </section>

        <section className="legal-section">
          <h2>{t('Одговорност')}</h2>
          <p>
            {t('Манастир Градац улаже разумне напоре да обезбеди тачност информација на овом веб-сајту, али не гарантује потпуну тачност, актуелност или комплетност садржаја.')}
          </p>
          <p>
            {t('Манастир Градац не сноси одговорност за било какву штету која може настати коришћењем или немогућношћу коришћења овог веб-сајта.')}
          </p>
        </section>

        <section className="legal-section">
          <h2>{t('Спољашње везе')}</h2>
          <p>
            {t('Овај веб-сајт може садржати везе ка веб-сајтовима трећих лица. Манастир Градац нема контролу над садржајем тих сајтова и не сноси одговорност за њихов садржај.')}
          </p>
        </section>

        <section className="legal-section">
          <h2>{t('Измене услова')}</h2>
          <p>
            {t('Манастир Градац задржава право да измени ове Услове коришћења у било ком тренутку. Измене ступају на снагу даном објављивања на овом веб-сајту.')}
          </p>
        </section>

        <section className="legal-section">
          <h2>{t('Меродавно право')}</h2>
          <p>
            {t('На ове Услове коришћења примењује се право Републике Србије. За решавање евентуалних спорова надлежан је суд у Србији.')}
          </p>
        </section>
      </div>
    </div>
  );
};

export default TermsOfUsePage;
